import { marketAsyncComponent } from '@/utils/asyncComponent';

export default marketAsyncComponent('vm-custom-panel', '0.0.1', { crossorigin: 'anonymous' });
